import { useEffect, useState } from 'react';
import { getConfig } from '../lib/config';

/**
 * Hook to manage dark mode state
 * Respects config.json darkModeEnabled setting
 */
export function useDarkMode() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check if dark mode is enabled in config
    try {
      const config = getConfig();
      const darkModeEnabled = config.darkModeEnabled || false;

      if (darkModeEnabled) {
        // If enabled, respect system preference
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        setIsDark(prefersDark);
        
        if (prefersDark) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      } else {
        // Dark mode disabled - force light mode
        setIsDark(false);
        document.documentElement.classList.remove('dark');
      }
    } catch (error) {
      // Config not loaded yet, default to light mode
      setIsDark(false);
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return { isDark };
}


